module.exports = __webpack_public_path__ + "img/anitta-icons.139c6eb4.svg";